// extracted by mini-css-extract-plugin
export default {"form":"L8iBI8cvLe2Qes4E4zeP"};